export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES 256-bit encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Experience blazing fast connection speeds without compromising security. Stream, download, and browse with minimal latency and maximum performance.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to our extensive network of high-speed servers located around the world. Access content from any region with reliable and stable connections.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and anonymous with our strict no-logging policy.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more. Secure up to 5 devices simultaneously.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is available around the clock to assist you. Get help whenever you need it through live chat, email, or phone support.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <strong>SALVI VPN</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our VPN application combines cutting-edge security technology with user-friendly design to deliver the ultimate privacy protection experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
                <i className={`${feature.icon} text-3xl text-teal-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                <strong>{feature.title}</strong>
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
